var $7267e2c772d79d5c$exports = {};
class $7267e2c772d79d5c$var$FileDrop extends HTMLElement {
    connectedCallback() {
        this.depth = 0;
        this.addEventListener('dragenter', this.onEnter);
        this.addEventListener('dragover', this.onOver);
        this.addEventListener('dragleave', this.onLeave);
        this.addEventListener('drop', this.onDrop);
    }
    disconnectedCallback() {
        this.removeEventListener('dragenter', this.onEnter);
        this.removeEventListener('dragover', this.onOver);
        this.removeEventListener('dragleave', this.onLeave);
        this.removeEventListener('drop', this.onDrop);
    }
    usable() {
        return this.hasAttribute('droppable');
    }
    onEnter = (event)=>{
        if (!this.usable()) return;
        this.depth += 1;
        if ($7267e2c772d79d5c$var$dragHasFiles(event)) {
            event.preventDefault();
            this.setAttribute('dragging', '');
        } else // A drag carrying no OS file (e.g. an in-app file-list item) can't be
        // attached here, so flag it as unsupported instead of inviting a drop.
        this.setAttribute('unsupported', '');
    };
    onOver = (event)=>{
        if (!this.usable()) return;
        // Only accept (preventDefault) a real file drag. A non-file drag is left
        // un-accepted, so the browser shows its definitive no-drop cursor — more
        // reliable than preventDefault + dropEffect="none".
        if ($7267e2c772d79d5c$var$dragHasFiles(event)) event.preventDefault();
    };
    onLeave = ()=>{
        this.depth = Math.max(0, this.depth - 1);
        if (this.depth === 0) {
            this.removeAttribute('dragging');
            this.removeAttribute('unsupported');
        }
    };
    onDrop = (event)=>{
        this.depth = 0;
        this.removeAttribute('dragging');
        this.removeAttribute('unsupported');
        if (!this.usable()) return;
        event.preventDefault();
        const transfer = event.dataTransfer;
        if (!transfer) return;
        // webkitGetAsEntry must be read synchronously, before any await:
        // the DataTransfer is emptied once this handler returns.
        const entries = [
            ...transfer.items
        ].filter((item)=>item.kind === 'file').map((item)=>item.webkitGetAsEntry && item.webkitGetAsEntry()).filter(Boolean);
        if (entries.length === 0) {
            this.emit([
                ...transfer.files
            ].map((file)=>({
                    file: file,
                    path: file.webkitRelativePath || file.name
                })));
            return;
        }
        $7267e2c772d79d5c$var$collectFiles(entries).then((files)=>this.emit(files));
    };
    // Each entry is { file, path }, where path is the folder-relative path.
    emit(files) {
        this.flashIfRejected(files);
        this.dispatchEvent(new CustomEvent('filesdropped', {
            detail: {
                files: files
            }
        }));
    }
    // Visual feedback when a drop includes files the field doesn't accept.
    // Elm still does the real filtering; this only flags the rejection.
    flashIfRejected(files) {
        const accept = this.getAttribute('accept');
        if (!accept || files.length === 0) return;
        if (files.some(({ file: file })=>!$7267e2c772d79d5c$var$matchesAccept(file, accept))) {
            this.setAttribute('rejected', '');
            clearTimeout(this._rejectTimer);
            this._rejectTimer = setTimeout(()=>this.removeAttribute('rejected'), 1800);
        }
    }
}
// True only when the drag carries actual OS files (a "Files" type). An in-app
// element drag — e.g. dragging a row out of the clinical files list — has other
// types (text/uri-list, custom) but no real file payload to attach.
function $7267e2c772d79d5c$var$dragHasFiles(event) {
    const transfer = event.dataTransfer;
    return Boolean(transfer && Array.from(transfer.types || []).includes('Files'));
}
function $7267e2c772d79d5c$var$matchesAccept(file, accept) {
    const tokens = accept.split(',').map((token)=>token.trim().toLowerCase()).filter(Boolean);
    if (tokens.length === 0) return true;
    const name = (file.name || '').toLowerCase();
    const type = (file.type || '').toLowerCase();
    return tokens.some((token)=>{
        if (token === '*' || token === '*/*') return true;
        if (token.startsWith('.')) return name.endsWith(token);
        if (token.endsWith('/*')) return type.startsWith(token.slice(0, -1));
        return type === token;
    });
}
function $7267e2c772d79d5c$var$collectFiles(entries) {
    return Promise.all(entries.map($7267e2c772d79d5c$var$walkEntry)).then((nested)=>nested.flat());
}
function $7267e2c772d79d5c$var$walkEntry(entry) {
    if (entry.isFile) return new Promise((resolve)=>{
        entry.file((file)=>resolve([
                {
                    file: file,
                    path: $7267e2c772d79d5c$var$cleanPath(entry.fullPath)
                }
            ]), ()=>resolve([]));
    });
    if (entry.isDirectory) return $7267e2c772d79d5c$var$readAllEntries(entry.createReader()).then($7267e2c772d79d5c$var$collectFiles);
    return Promise.resolve([]);
}
function $7267e2c772d79d5c$var$cleanPath(fullPath) {
    return fullPath.replace(/^\//, '');
}
// readEntries returns directory children in chunks; call until it returns none.
function $7267e2c772d79d5c$var$readAllEntries(reader, acc = []) {
    return new Promise((resolve)=>{
        reader.readEntries((batch)=>{
            if (batch.length === 0) resolve(acc);
            else resolve($7267e2c772d79d5c$var$readAllEntries(reader, acc.concat(batch)));
        }, ()=>resolve(acc));
    });
}
customElements.define('file-drop', $7267e2c772d79d5c$var$FileDrop);


//# sourceMappingURL=project.ba257e0c.js.map
